import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'

import {
  DashboardModule, Form, HoverHintWrapper, Text,
} from '@domain-group/suit-theme'

import type { UseBrandFormPayload } from '@hooks/useBrand'
import useCurrentUser from '@hooks/useCurrentUser'

import EntitySelector from '@components/EntitySelector'

interface TemplateSettingsProps {
  brandFormPayload: UseBrandFormPayload,
}

const TemplateSettings = (props: TemplateSettingsProps) => {
  const { brandFormPayload } = props

  const {
    entityState: {
      debtor_agency_id,
      options,
      id: brandId,
    },
    handlers,
    setEntityState,
  } = brandFormPayload

  const { realhub_platform, template_page_fee, template_page_monthly_allowance } = options

  const { isBrandUser } = useCurrentUser()

  return (
    <DashboardModule title="Template Settings">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Template Page Fee">
            <input
              data-validate-field-on="change"
              disabled={isBrandUser}
              name="options.template_page_fee"
              type="number"
              value={template_page_fee}
              {...handlers}
            />
          </Form.Field>

          {/* @ts-expect-error TS2322 */}
          <Form.Field label="Free Templates (Monthly)" marginTop={['large', 0]}>
            <input
              data-validate-field-on="change"
              disabled={isBrandUser}
              name="options.template_page_monthly_allowance"
              type="number"
              value={template_page_monthly_allowance}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          {!isBrandUser && (
            <Form.Field label="Realhub Platform">
              {/*
              // @ts-expect-error TS2322 */}
              <select
                disabled={isBrandUser}
                name="options.realhub_platform"
                value={realhub_platform}
                {...handlers}
              >
                <option value="standalone_v1">Standalone</option>
              </select>
            </Form.Field>
          )}

          <Form.Field>
            <EntitySelector
              searchRequestOptions={{
                brand_id: brandId,
              }}
              callbacks={{
                selectItem: agency => setEntityState({ debtor_agency_id: agency ? agency.id : null }),
              }}
              entityKey="agencies"
              // @ts-expect-error TS2741
              label={(
                <HoverHintWrapper
                  boxProps={{ display: 'inline-block', position: 'relative', width: '100%' }}
                  hintComponent={(
                    <HoverHintWrapper.Hint>
                      The debtor agency is the default agency that is set in Template Manager
                      that will be invoiced for the brand&apos;s templates.
                    </HoverHintWrapper.Hint>
                  )}
                  // @ts-expect-error TS2322
                  width="fit-content"
                >
                  <Text
                    color="bodyFontLightColor"
                    size="small"
                    fontSize={12}
                    letterSpacing="1px"
                  >
                    Debtor Agency
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Text>
                </HoverHintWrapper>
)}
              // @ts-expect-error TS2322
              marginTop={['large', 0]}
              selectedItemId={debtor_agency_id}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default TemplateSettings
